import { __awaiter } from 'tslib';
import { getRequest } from '@navify-platform/http';

var EnvProp;
(function (EnvProp) {
    EnvProp["AppAlias"] = "appAlias";
    EnvProp["UrlScheme"] = "urlScheme";
    EnvProp["PlatformApiUrl"] = "platformApiUrl";
    EnvProp["PlatformAppAlias"] = "platformAppAlias";
    EnvProp["ProductApiUrl"] = "productApiUrl";
    EnvProp["AuthType"] = "authType";
    EnvProp["AuthUiUrl"] = "authUiUrl";
    EnvProp["AuthOktaIssuer"] = "authOktaIssuer";
    EnvProp["AuthOktaClientId"] = "authOktaClientId";
    EnvProp["AppdEndUserMonitoring"] = "appdEndUserMonitoring";
    EnvProp["AppdEndUserMonitoringKey"] = "appdEndUserMonitoringKey";
    EnvProp["CfDistributionId"] = "cfDistributionId";
    EnvProp["TenantAlias"] = "tenantAlias";
})(EnvProp || (EnvProp = {}));
var EnvParam;
(function (EnvParam) {
    EnvParam["AppAlias"] = "APP_ALIAS";
    EnvParam["UrlScheme"] = "URL_SCHEME";
    EnvParam["PlatformApiUrl"] = "API_GATEWAY_ADDRESS";
    EnvParam["PlatformAppAlias"] = "PLATFORM_APP_ALIAS";
    EnvParam["ProductApiUrl"] = "PRODUCT_API_GATEWAY_ADDRESS";
    EnvParam["AuthType"] = "AUTH_TYPE";
    EnvParam["AuthUiUrl"] = "AUTH_UI_ADDRESS";
    EnvParam["AuthOktaIssuer"] = "OKTA.ISSUER";
    EnvParam["AuthOktaClientId"] = "OKTA.CLIENT_ID";
    EnvParam["AppdEndUserMonitoring"] = "APPDYNAMICS_END_USER_MONITORING";
    EnvParam["AppdEndUserMonitoringKey"] = "APPDYNAMICS_END_USER_MONITORING_KEY";
    EnvParam["CfDistributionId"] = "CF_DISTRIBUTION_ID";
    EnvParam["TenantAlias"] = "TENANT_ALIAS";
})(EnvParam || (EnvParam = {}));
var EnvSourceOrigin;
(function (EnvSourceOrigin) {
    EnvSourceOrigin["Seed"] = "seed";
    EnvSourceOrigin["Param"] = "param";
    EnvSourceOrigin["Default"] = "default";
})(EnvSourceOrigin || (EnvSourceOrigin = {}));
var EnvSourceType;
(function (EnvSourceType) {
    EnvSourceType["String"] = "string";
    EnvSourceType["Number"] = "number";
    EnvSourceType["Boolean"] = "boolean";
    EnvSourceType["Url"] = "url";
})(EnvSourceType || (EnvSourceType = {}));
;

const ENV_DATA_CONST_ENCODED = 'eyJlbnZQbGFjZWhvbGRlciI6dHJ1ZX0='; // atob(JSON.stringify({envPlaceholder: true}))
const ENV_DATA_FILE_URI = '/navify-env.json';
const ENV_PROP_SOURCES = {
    [EnvProp.AppAlias]: [
        { origin: EnvSourceOrigin.Seed, key: EnvProp.AppAlias, type: EnvSourceType.String },
        { origin: EnvSourceOrigin.Param, key: EnvParam.AppAlias, type: EnvSourceType.String },
        { origin: EnvSourceOrigin.Default, key: EnvProp.AppAlias, type: EnvSourceType.String },
    ],
    [EnvProp.UrlScheme]: [
        { origin: EnvSourceOrigin.Seed, key: EnvProp.UrlScheme, type: EnvSourceType.String },
        { origin: EnvSourceOrigin.Param, key: EnvParam.UrlScheme, type: EnvSourceType.String },
        { origin: EnvSourceOrigin.Default, key: EnvProp.UrlScheme, type: EnvSourceType.String },
    ],
    [EnvProp.PlatformApiUrl]: [
        { origin: EnvSourceOrigin.Seed, key: EnvProp.PlatformApiUrl, type: EnvSourceType.Url },
        { origin: EnvSourceOrigin.Param, key: EnvParam.PlatformApiUrl, type: EnvSourceType.Url },
        { origin: EnvSourceOrigin.Default, key: EnvProp.PlatformApiUrl, type: EnvSourceType.Url },
    ],
    [EnvProp.PlatformAppAlias]: [
        { origin: EnvSourceOrigin.Seed, key: EnvProp.PlatformAppAlias, type: EnvSourceType.String },
        { origin: EnvSourceOrigin.Param, key: EnvParam.PlatformAppAlias, type: EnvSourceType.String },
        { origin: EnvSourceOrigin.Default, key: EnvProp.PlatformAppAlias, type: EnvSourceType.String },
    ],
    [EnvProp.ProductApiUrl]: [
        { origin: EnvSourceOrigin.Seed, key: EnvProp.ProductApiUrl, type: EnvSourceType.Url },
        { origin: EnvSourceOrigin.Param, key: EnvParam.ProductApiUrl, type: EnvSourceType.Url },
        { origin: EnvSourceOrigin.Default, key: EnvProp.ProductApiUrl, type: EnvSourceType.Url },
    ],
    [EnvProp.AuthType]: [
        { origin: EnvSourceOrigin.Seed, key: EnvProp.AuthType, type: EnvSourceType.String },
        { origin: EnvSourceOrigin.Param, key: EnvParam.AuthType, type: EnvSourceType.String },
        { origin: EnvSourceOrigin.Default, key: EnvProp.AuthType, type: EnvSourceType.String },
    ],
    [EnvProp.AuthUiUrl]: [
        { origin: EnvSourceOrigin.Seed, key: EnvProp.AuthUiUrl, type: EnvSourceType.Url },
        { origin: EnvSourceOrigin.Param, key: EnvParam.AuthUiUrl, type: EnvSourceType.Url },
        { origin: EnvSourceOrigin.Default, key: EnvProp.AuthUiUrl, type: EnvSourceType.Url },
    ],
    [EnvProp.AuthOktaIssuer]: [
        { origin: EnvSourceOrigin.Seed, key: EnvProp.AuthOktaIssuer, type: EnvSourceType.String },
        { origin: EnvSourceOrigin.Param, key: EnvParam.AuthOktaIssuer, type: EnvSourceType.String },
        { origin: EnvSourceOrigin.Default, key: EnvProp.AuthOktaIssuer, type: EnvSourceType.String },
    ],
    [EnvProp.AuthOktaClientId]: [
        { origin: EnvSourceOrigin.Seed, key: EnvProp.AuthOktaClientId, type: EnvSourceType.String },
        { origin: EnvSourceOrigin.Param, key: EnvParam.AuthOktaClientId, type: EnvSourceType.String },
        { origin: EnvSourceOrigin.Default, key: EnvProp.AuthOktaClientId, type: EnvSourceType.String },
    ],
    [EnvProp.AppdEndUserMonitoring]: [
        { origin: EnvSourceOrigin.Seed, key: EnvProp.AppdEndUserMonitoring, type: EnvSourceType.Boolean },
        { origin: EnvSourceOrigin.Param, key: EnvParam.AppdEndUserMonitoring, type: EnvSourceType.Boolean },
        { origin: EnvSourceOrigin.Default, key: EnvProp.AppdEndUserMonitoring, type: EnvSourceType.String },
    ],
    [EnvProp.AppdEndUserMonitoringKey]: [
        { origin: EnvSourceOrigin.Seed, key: EnvProp.AppdEndUserMonitoringKey, type: EnvSourceType.String },
        { origin: EnvSourceOrigin.Param, key: EnvParam.AppdEndUserMonitoringKey, type: EnvSourceType.String },
        { origin: EnvSourceOrigin.Default, key: EnvProp.AppdEndUserMonitoringKey, type: EnvSourceType.String },
    ],
    [EnvProp.CfDistributionId]: [
        { origin: EnvSourceOrigin.Seed, key: EnvProp.CfDistributionId, type: EnvSourceType.String },
        { origin: EnvSourceOrigin.Param, key: EnvParam.CfDistributionId, type: EnvSourceType.String },
        { origin: EnvSourceOrigin.Default, key: EnvProp.CfDistributionId, type: EnvSourceType.String },
    ],
    [EnvProp.TenantAlias]: [
        { origin: EnvSourceOrigin.Seed, key: EnvProp.TenantAlias, type: EnvSourceType.String },
        { origin: EnvSourceOrigin.Param, key: EnvParam.TenantAlias, type: EnvSourceType.String },
        { origin: EnvSourceOrigin.Default, key: EnvProp.TenantAlias, type: EnvSourceType.String },
    ],
};
const ENV_PROP_DEFAULTS = {
    [EnvProp.UrlScheme]: 'https:',
    [EnvProp.PlatformAppAlias]: 'platform',
    [EnvProp.AppdEndUserMonitoring]: false,
    [EnvProp.AppdEndUserMonitoringKey]: null,
};
const ENV_CAST_TRUE_REGEX = /(true|t)/i;
const ENV_CAST_FALSE_REGEX = /(false|f)/i;

const URL_SCHEME_REGEX = /^(\w+:)?\/\//;
/**
 * @hidden
 */
function getUrlScheme(url) {
    const matches = url.match(URL_SCHEME_REGEX);
    if (matches === null) {
        return null;
    }
    return matches[1] || '';
}

class Env {
    constructor(seed = null) {
        this.seed = seed;
    }
    haveDeployConst() {
        if (this.deployConst === undefined) {
            const deployConst = this.evalDeployConst();
            this.setDeployConst(deployConst);
        }
    }
    evalDeployConst() {
        try {
            const deployConst = JSON.parse(atob(ENV_DATA_CONST_ENCODED));
            return deployConst;
        }
        catch (error) {
            return null;
        }
    }
    setDeployConst(deployConst) {
        this.deployConst = deployConst;
    }
    haveDeployFile() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.deployFile === undefined) {
                this.deployFile = yield this.fetchDeployFile();
            }
            return this.deployFile;
        });
    }
    fetchDeployFile() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield getRequest(`${ENV_DATA_FILE_URI}?${Date.now()}`);
            }
            catch (error) {
                if (((_a = error === null || error === void 0 ? void 0 : error.faults) === null || _a === void 0 ? void 0 : _a.httpNotFound) || ((_b = error === null || error === void 0 ? void 0 : error.faults) === null || _b === void 0 ? void 0 : _b.httpException)) {
                    return null;
                }
                throw error;
            }
        });
    }
    getProp(propName) {
        return __awaiter(this, void 0, void 0, function* () {
            const propSources = ENV_PROP_SOURCES[propName];
            if (propSources) {
                return this.pullProp(propSources);
            }
            const defaultSources = [
                { origin: EnvSourceOrigin.Seed, key: propName },
                { origin: EnvSourceOrigin.Default, key: propName },
            ];
            return this.pullProp(defaultSources);
        });
    }
    pullProp(sources) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!sources || !sources[0]) {
                return undefined;
            }
            const [source, ...otherSources] = sources;
            const { origin, key, type } = source;
            let value;
            switch (true) {
                case origin === EnvSourceOrigin.Seed:
                    value = yield this.getPropFromSeed(key);
                    break;
                case origin === EnvSourceOrigin.Param:
                    value = yield this.getParam(key);
                    break;
                case origin === EnvSourceOrigin.Default:
                    value = yield this.getPropFromDefault(key);
                    break;
            }
            if (value === undefined) {
                return yield this.pullProp(otherSources);
            }
            if (type) {
                value = yield this.castType(value, type);
            }
            return value;
        });
    }
    ;
    getPropFromSeed(propName) {
        return __awaiter(this, void 0, void 0, function* () {
            const seedProps = this.seed && this.seed.props;
            if (seedProps && propName in seedProps) {
                const seedProp = seedProps[propName];
                if (typeof seedProp === 'function') {
                    try {
                        return yield seedProp(propName);
                    }
                    catch (error) {
                        return undefined;
                    }
                }
                return seedProp;
            }
            return undefined;
        });
    }
    getParam(paramName, type = null) {
        return __awaiter(this, void 0, void 0, function* () {
            const seedParam = yield this.getParamFromSeed(paramName, type);
            if (seedParam !== undefined) {
                return seedParam;
            }
            const constParam = yield this.getParamFromConst(paramName, type);
            if (constParam !== undefined) {
                return constParam;
            }
            const envFileParam = yield this.getParamFromFile(paramName, type);
            if (envFileParam !== undefined) {
                return envFileParam;
            }
            return undefined;
        });
    }
    getStringParam(paramName) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.getParam(paramName, EnvSourceType.String));
        });
    }
    getNumberParam(paramName) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.getParam(paramName, EnvSourceType.Number));
        });
    }
    getBooleanParam(paramName) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.getParam(paramName, EnvSourceType.Boolean));
        });
    }
    getUrlParam(paramName) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.getParam(paramName, EnvSourceType.Url));
        });
    }
    getParamFromSeed(paramName, type = null) {
        return __awaiter(this, void 0, void 0, function* () {
            let value = undefined;
            const seedParams = this.seed && this.seed.params;
            if (seedParams && paramName in seedParams) {
                value = seedParams[paramName];
            }
            if (value !== undefined && type) {
                value = yield this.castType(value, type);
            }
            return value;
        });
    }
    getParamFromConst(paramName, type = null) {
        return __awaiter(this, void 0, void 0, function* () {
            this.haveDeployConst();
            let value = undefined;
            const envConstParams = this.deployConst && this.deployConst.params;
            if (envConstParams && paramName in envConstParams) {
                value = envConstParams[paramName];
            }
            if (value !== undefined && type) {
                value = yield this.castType(value, type);
            }
            return value;
        });
    }
    getParamFromFile(paramName, type = null) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.haveDeployFile();
            let value = undefined;
            const envFileParams = this.deployFile && this.deployFile.params;
            if (envFileParams && paramName in envFileParams) {
                value = envFileParams[paramName];
            }
            if (value !== undefined && type) {
                value = yield this.castType(value, type);
            }
            return value;
        });
    }
    getPropFromDefault(propName) {
        return __awaiter(this, void 0, void 0, function* () {
            const seedDefaults = this.seed && this.seed.defaults;
            if (seedDefaults && propName in seedDefaults) {
                const seedDefault = seedDefaults[propName];
                if (typeof seedDefault === 'function') {
                    return yield seedDefault(propName);
                }
                return seedDefault;
            }
            if (propName in ENV_PROP_DEFAULTS) {
                return ENV_PROP_DEFAULTS[propName];
            }
            return undefined;
        });
    }
    castType(value, type) {
        return __awaiter(this, void 0, void 0, function* () {
            if (type === EnvSourceType.String) {
                return yield this.castString(value);
            }
            if (type === EnvSourceType.Number) {
                return yield this.castNumber(value);
            }
            if (type === EnvSourceType.Boolean) {
                return yield this.castBoolean(value);
            }
            if (type === EnvSourceType.Url) {
                return yield this.castUrl(value);
            }
        });
    }
    castString(value) {
        return __awaiter(this, void 0, void 0, function* () {
            return value ? `${value}` : '';
        });
    }
    castNumber(value) {
        return __awaiter(this, void 0, void 0, function* () {
            return value ? parseFloat(value) : 0;
        });
    }
    castBoolean(value) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof value === 'string') {
                if (value.match(ENV_CAST_TRUE_REGEX)) {
                    return true;
                }
                if (value.match(ENV_CAST_FALSE_REGEX)) {
                    return false;
                }
            }
            return !!value;
        });
    }
    castUrl(value) {
        return __awaiter(this, void 0, void 0, function* () {
            let url = yield this.castString(value);
            const urlScheme = getUrlScheme(url);
            if (urlScheme === null) {
                const urlSchemeAlt = yield this.getUrlScheme();
                url = `${urlSchemeAlt}//${url}`;
            }
            return url;
        });
    }
    getAppAlias() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.getProp(EnvProp.AppAlias));
        });
    }
    getUrlScheme() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.getProp(EnvProp.UrlScheme));
        });
    }
    getPlatformApiUrl() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.getProp(EnvProp.PlatformApiUrl));
        });
    }
    getPlatformAppAlias() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.getProp(EnvProp.PlatformAppAlias));
        });
    }
    getProductApiUrl() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.getProp(EnvProp.ProductApiUrl));
        });
    }
    getAuthType() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.getProp(EnvProp.AuthType));
        });
    }
    getAuthUiUrl() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.getProp(EnvProp.AuthUiUrl));
        });
    }
    getAuthOktaIssuer() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.getProp(EnvProp.AuthOktaIssuer));
        });
    }
    getAuthOktaClientId() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.getProp(EnvProp.AuthOktaClientId));
        });
    }
    getAppdEndUserMonitoring() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.getProp(EnvProp.AppdEndUserMonitoring));
        });
    }
    getAppdEndUserMonitoringKey() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.getProp(EnvProp.AppdEndUserMonitoringKey));
        });
    }
    getCfDistributionId() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.getProp(EnvProp.CfDistributionId));
        });
    }
    getTenantAlias() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.getProp(EnvProp.TenantAlias));
        });
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { ENV_CAST_FALSE_REGEX, ENV_CAST_TRUE_REGEX, ENV_DATA_CONST_ENCODED, ENV_DATA_FILE_URI, ENV_PROP_DEFAULTS, ENV_PROP_SOURCES, Env, EnvParam, EnvProp, EnvSourceOrigin, EnvSourceType };

